import { formatFullMonthName } from "@clipboard-health/date-time";
import { Text } from "@clipboard-health/ui-components";
import { Stack } from "@mui/material";
import { IconButton } from "@src/appV2/redesign/components/IconButton";
import { useDefinedWorker } from "@src/appV2/Worker/useDefinedWorker";

interface MonthNavigationHeaderProps {
  currentMonthDate: Date;
  isFirstMonth: boolean;
  isLastMonth: boolean;
  onPreviousMonth: () => void;
  onNextMonth: () => void;
}

export function MonthNavigationHeader(props: MonthNavigationHeaderProps) {
  const { currentMonthDate, isFirstMonth, isLastMonth, onPreviousMonth, onNextMonth } = props;
  const worker = useDefinedWorker();
  const timeZone = worker.tmz ?? Intl.DateTimeFormat().resolvedOptions().timeZone;

  return (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      spacing={2}
      sx={{ px: 5 }}
    >
      <IconButton
        size="small"
        iconType="chevron-left"
        variant="ghost"
        disabled={isFirstMonth}
        aria-label="Previous month"
        onClick={onPreviousMonth}
      />

      <Text variant="h5" sx={{ flexGrow: 1, textAlign: "center" }}>
        {currentMonthDate ? formatFullMonthName(currentMonthDate, { timeZone }) : ""}
      </Text>

      <IconButton
        size="small"
        iconType="chevron-right"
        variant="ghost"
        disabled={isLastMonth}
        aria-label="Next month"
        onClick={onNextMonth}
      />
    </Stack>
  );
}
